module.exports = __webpack_public_path__ + "static/media/proworking.09643446.png";